import { Link, ListItem } from "@mui/material"
import { getAmendsKeyLabel } from "authoring/routes/project/amends/lib/required-amends-helpers"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useOkCancelContext } from "lib/@hooks/useOkCancelContext"
import { navigateScheduleEditor } from "authoring/routes/project/utilities/project-navigation"

export function MissingAmendItem({ amendsKey, schedule }) {
    const { target: project } = useBoundContext()
    const { cancel } = useOkCancelContext()
    const label = getAmendsKeyLabel({ amendsKey, draft: schedule })

    return (
        <ListItem sx={{ typography: "body2" }}>
            <Link
                sx={{ cursor: "pointer", color: "inherit", textDecorationColor: "text.secondary" }}
                onClick={handleClick}
                data-cy="missing-amend-link"
            >
                {label}
            </Link>
        </ListItem>
    )

    function handleClick() {
        cancel()
        navigateScheduleEditor({
            projectId: project?.id,
            scheduleId: schedule.id,
            openAmend: amendsKey,
        })
    }
}
